<template>
  <div class="price-selector" v-if="visible">
    <!-- 选项列表 -->
    <div class="options-list">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="option-item"
        :class="{ active: selectedIndex === index }"
        @click="selectOption(index)"
      >
        <!-- 图片模式 -->
        <template v-if="displayMode === 'image' || displayMode === 'mixed'">
          <img
            :src="selectedIndex === index ? option.activeImage : option.image"
            :alt="option.label || '选项' + (index + 1)"
            class="option-image"
          />
        </template>

        <!-- 单选框 - 仅在文字模式或混合模式时显示 -->
        <div
          v-if="displayMode === 'text' || displayMode === 'mixed'"
          class="radio-box"
          :class="{ checked: selectedIndex === index }"
        >
          <div class="radio-inner" v-if="selectedIndex === index">
            <i class="check-icon">✓</i>
          </div>
        </div>

        <!-- 文字模式 -->
        <template v-if="displayMode === 'text' || displayMode === 'mixed'">
          <div
            class="option-text"
            :style="selectedIndex === index ? activeTextStyle : textStyle"
          >
            <div class="text-row">
              <span class="option-label" v-if="option.label">{{ option.label }}</span>
              <span class="option-price" v-if="option.price">
                <span class="price-symbol" v-if="option.symbol">{{ option.symbol }}</span>
                <span class="price-value" :style="priceValueStyle">{{ option.price }}</span>
                <span class="price-unit" v-if="option.unit">{{ option.unit }}</span>
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 选中信息展示 -->
    <!-- <div class="selected-info" v-if="showSelectedInfo && selectedOption">
      <div class="info-label">已选择：</div>
      <div class="info-content">
        <span class="info-name">{{ selectedOption.label }}</span>
        <span class="info-price" :style="selectedPriceStyle">
          {{ selectedOption.price?.symbol }}{{ selectedOption.price?.value }}{{ selectedOption.price?.unit }}
        </span>
        <span class="info-billing">{{ selectedOption.billing }}</span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PriceSelector',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedIndex: 0
    }
  },
  created() {
    this.selectOption(this.selectedIndex)
  },
  computed: {
    // 是否可见
    visible() {
      return this.config.visible !== false
    },

    // 显示模式：image-图片, text-文字, mixed-图文混合
    displayMode() {
      return this.config.displayMode || 'text'
    },

    // 选项列表
    options() {
      return this.config.options || this.defaultOptions
    },

    // 默认选项
    defaultOptions() {
      return [
        {
          label: '连续包月',
          image: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857102650.png',
          activeImage: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857106815.png',
          price: {
            symbol: '¥',
            value: '19.9',
            unit: '/月'
          },
          billing: '连续包月，可随时取消',
          mode: 'subscription'
        },
        {
          label: '年费会员',
          image: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857111493.png',
          activeImage: 'https://static-cos.jetmobo.com/image/content-h5/20250730/1753857114994.png',
          price: {
            symbol: '¥',
            value: '199',
            unit: '/年'
          },
          billing: '一次性付费，有效期一年',
          mode: 'yearly'
        }
      ]
    },

    // 默认选中索引
    defaultIndex() {
      return this.config.defaultIndex || 0
    },

    // 当前选中的选项
    selectedOption() {
      return this.options[this.selectedIndex]
    },

    // 是否显示选中标记
    showCheckMark() {
      return this.config.showCheckMark !== false
    },

    // 是否显示选中信息
    showSelectedInfo() {
      return this.config.showSelectedInfo !== false
    },

    // 文字样式（未选中）- 参考 uni-view 样式：半透明白色
    textStyle() {
      return {
        color: this.config.textStyle?.color || 'rgba(255, 255, 255, 0.5)',
        fontSize: this.config.textStyle?.fontSize || '0.28rem',
        backgroundColor: this.config.textStyle?.backgroundColor || 'transparent'
      }
    },

    // 文字样式（选中）- 参考 uni-view 样式：纯白色
    activeTextStyle() {
      return {
        color: this.config.activeTextStyle?.color || '#FFFFFF',
        fontSize: this.config.activeTextStyle?.fontSize || '0.28rem',
        backgroundColor: this.config.activeTextStyle?.backgroundColor || 'transparent'
      }
    },

    // 价格数值样式 - 继承父元素颜色
    priceValueStyle() {
      return {
        color: this.config.priceStyle?.color || 'inherit',
        fontSize: this.config.priceStyle?.fontSize || '0.32rem',
        fontWeight: this.config.priceStyle?.fontWeight || '600'
      }
    },

    // 选中价格样式
    selectedPriceStyle() {
      return {
        color: this.config.selectedPriceStyle?.color || '#FFFFFF',
        fontSize: this.config.selectedPriceStyle?.fontSize || '0.32rem',
        fontWeight: this.config.selectedPriceStyle?.fontWeight || '600'
      }
    }
  },
  watch: {
    defaultIndex: {
      immediate: true,
      handler(val) {
        this.selectedIndex = val
      }
    }
  },
  methods: {
    selectOption(index) {
      this.selectedIndex = index
      const option = this.options[index]

      // 触发事件
      this.$emit('action', {
        type: 'priceSelect',
        data: {
          index: index,
          price: option.price,
          package: option.package
        }
      })

      // 全局事件（用于表单收集）
      this.$emit('change', {
        index: index,
        price: option.price?.value,
        billing: option.billing,
        package: option.package
      })
    }
  }
}
</script>

<style lang="less" scoped>
.price-selector {
  width: 100%;
  padding: 0.2rem;
}

.options-list {
  display: flex;
  flex-direction: row;
  gap: 0.2rem;
}

.option-item {
  position: relative;
  flex: 1;
  border-radius: 0.1rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 0.3rem;
  justify-content: center;

  &:active {
    opacity: 0.9;
  }
}

// 图片样式
.option-image {
  width: 50%;
  height: auto;
  display: block;
}

// 文字样式
.option-text {
  flex: 1;
  border-radius: 0.1rem;

  .text-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.2rem;

    .option-label {
      font-size: 0.25rem;
      // font-weight: bold;
      white-space: nowrap;
    }

    .option-price {
      display: flex;
      align-items: baseline;
      gap: 0.05rem;
      white-space: nowrap;

      .price-symbol {
        font-size: 0.24rem;
      }

      .price-value {
        font-weight: bold;
      }

      .price-unit {
        font-size: 0.24rem;
      }
    }
  }
}

// 单选框
.radio-box {
  width: 0.36rem;
  height: 0.36rem;
  border: 0.02rem solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &.checked {
    border-color: #fff;
    background: #fff;
  }

  .radio-inner {
    display: flex;
    align-items: center;
    justify-content: center;

    .check-icon {
      color: #E7401E;
      font-size: 0.2rem;
      font-style: normal;
    }
  }
}

// 选中信息展示
.selected-info {
  margin-top: 0.2rem;
  padding: 0.2rem;
  background: #f8f9fa;
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  gap: 0.1rem;

  .info-label {
    font-size: 0.24rem;
    color: #666;
  }

  .info-content {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    flex-wrap: wrap;

    .info-name {
      font-size: 0.28rem;
      font-weight: bold;
      color: #333;
    }

    .info-price {
      font-weight: bold;
    }

    .info-billing {
      font-size: 0.22rem;
      color: #999;
    }
  }
}
</style>
